module.exports = __webpack_public_path__ + "static/img/24-红英小学(韩家川校区).0df361c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/24-红英小学(韩家川校区).png
// module id = VyOs
// module chunks = 0